import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../../LabelText';
import RadioInput from './Input';
import { getUserFieldValue } from '../../../../Util/Util';
const Radio = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component, formFields} = props;
	const [checkedValue, setCheckedValue] = useState('');

	const fv = useSelector(state => state.fv);

	const userData = useSelector(state => state.userData);
	let userFieldValue = getUserFieldValue(form_component.fieldname, userData);

	useEffect(() => { // to be updated after render
		i18n.changeLanguage(props.lang);

		var select_radio_default_value = '';

		form_component.options.map((option, index) => {
			if (option.default_select) {
				select_radio_default_value = option.value;
			}

			if (userFieldValue === option.value || select_radio_default_value === option.value) {
				setCheckedValue(option.value);
			}
		});
	}, []);

	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			var validator = {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			};

			fv.addField(form_component.fieldname, validator);
		}
	}, [fv]);

	return (
		<div className={`flex-grow-1 form-group ${form_component.required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			{!form_component.required && (
				<input type="hidden" name={form_component.fieldname} />
			)}
			<div className={`label_box ${form_component.option_display === '1R1O' ? 'label-full' : 'label-50'}`}>
				{(() => {
					const components = [];

					form_component.options.map((option, index) => {
						components.push(
							<RadioInput
								key={`input-${index}`}
								lang={props.lang}
								form_component={form_component}
								formFields={formFields}
								option={option}
								checkedValue={checkedValue}
								setCheckedValue={setCheckedValue}
							/>
						);
					});

					if (form_component.has_other_option) {
						components.push(
							<RadioInput
								key={`input-other`}
								lang={props.lang}
								formFields={formFields}
								form_component={form_component}
								option={{
									label: form_component.other_option_label,
									value: 'other'
								}}
								checkedValue={checkedValue}
								setCheckedValue={setCheckedValue}
							/>
						);
					}

					return components;
				})()}
			</div>
		</div>
	);
}

export default Radio;